// var galleryThumbs = new Swiper('.gallery-thumbs', {
// 	spaceBetween: 0,
// 	slidesPerView: 4,
// 	freeMode: true,
// 	watchSlidesVisibility: true,
// 	watchSlidesProgress: true,
// });

var productSlider = new Swiper('.product-container', {
	spaceBetween: 16,
	slidesPerView: 1,
	autoHeight: false,
	centeredSlides: false,
	observeParents: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		500: {
			slidesPerView: 2,
			centeredSlides: false,
		},
		700: {
			slidesPerView: 3,
			centeredSlides: false,
		},
		900: {
			slidesPerView: 4,
			centeredSlides: false,
		}
	},
	scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
    }
});


// Get slider element
const slider = document.querySelector('.productListing-parent-container');

// Listen for transition end event
slider.addEventListener('transitionend', setLayout);

setLayout();

function setLayout() {
	const slides = document.querySelectorAll('.product-container .swiper-slide');
	let layout = ''; // Initialize the layout variable outside the loop

	for (let i = 0; i < slides.length; i++) {
		const slide = slides[i];

		if (slide.classList.contains('swiper-slide-active')) {
			layout = slide.getAttribute('data-layout'); // Store the layout value in the variable
			break;
		}
	}
}
